module.exports = "<my-copy-wagons-input></my-copy-wagons-input>\n\n<!-- <my-tables my-data=\"wagons\"\n  my-nature=\"'wagon'\"\n  disabled-list=\"true\">\n</my-tables> -->\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/search/templates/home.html
// module id = 1562
// module chunks = 0